import { render, staticRenderFns } from "./bottomSwiper.vue?vue&type=template&id=e380ab24&scoped=true"
import script from "./bottomSwiper.vue?vue&type=script&lang=js"
export * from "./bottomSwiper.vue?vue&type=script&lang=js"
import style0 from "./bottomSwiper.vue?vue&type=style&index=0&id=e380ab24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e380ab24",
  null
  
)

export default component.exports